<template>
  <section data-testid="deals-header-wrapper" :class="{ 'sticky-header': filtersNotEmpty }">
    <div ref="offersHeader" class="bg-light-gray">
      <section class="container">
        <OffersFilters
          :selected-region="filter.region"
          :selected-dates-range="selectedDatesRange"
          :more-filters-counter="moreFiltersCounter"
          @datesChange="changeDateRange"
          @openMoreFilters="emitOpenMoreFilters"
        />
      </section>
      <div class="bg-white">
        <div class="offers container">
          <div class="offers__filters2">
            <div style="flex: auto; width: 0">
              <CategoriesFilter
                :categories="facets.categories"
                @select="selectSingleCategory"
                @unselect="unselectCategory"
              />
            </div>
            <div class="filters-controls-wrapper">
              <MoreFiltersBtn
                data-testid="more-filters-btn"
                :counter="moreFiltersCounter"
                @click="emitOpenMoreFilters"
              />
            </div>
          </div>
              <div class="d-none d-lg-block">
                <ClearAllFiltersBtn
                  v-if="filter.nonEmpty() || isSeeAllFilter"
                  data-testid="button-clear-filters-mobile"
                  @click="emitClearFilters"
                />
                </div>
          <div
            v-if="filter.nonEmpty() || isSeeAllFilter"
            class="container filters-controls-wrapper__mobile"
          >
            <ClearAllFiltersBtn
              data-testid="button-clear-filters-desktop"
              mobile
              @click="emitClearFilters"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import OffersFilters from '@/components/offers/OffersFilters'
import CategoriesFilter from '@/components/filters/CategoriesFilter'
import MoreFiltersBtn from '@/components/filters/MoreFiltersBtn'
import ClearAllFiltersBtn from '@/components/filters/ClearAllFiltersBtn'

const { mapActions, mapGetters } = createNamespacedHelpers('newOffers')

export default {
  name: 'OffersHeader',
  components: {
    OffersFilters,
    CategoriesFilter,
    MoreFiltersBtn,
    ClearAllFiltersBtn
  },
  emits: ['openMoreFilters', 'clearFilters'],
  data() {
    return {
      resizeObserver: null,
      spacerHeight: 0
    }
  },
  computed: {
    ...mapGetters(['facets', 'filter', 'isSeeAllFilter']),
    selectedDatesRange() {
      return { start: this.filter.startDate, end: this.filter.endDate }
    },
    filtersNotEmpty() {
      return !!this.filter.nonEmpty()
    },
    moreFiltersCounter() {
      const filters = [this.filter.isRewardsOnly, this.filter.hasBrands()]
      return filters.filter(Boolean).length // gets the number of truthy values in filters arr
    }
  },
  methods: {
    ...mapActions(['changeDateRange', 'selectSingleCategory', 'unselectCategory', 'selectLocation']),
    emitClearFilters() {
      this.$emit('clearFilters')
    },
    emitOpenMoreFilters() {
      this.$emit('openMoreFilters')
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-controls-wrapper {
  display: flex;
  flex-direction: column;

  @media (max-width: media('tablet-l')) {
    display: none;
  }

  &__mobile {
    display: none;

    @media (max-width: media('tablet-l')) {
      display: block;
      margin-top: 0;
      margin-bottom: 2rem;
    }
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: zindex('cover-content');
  border-bottom: 1px solid color('grey-soft');
}

.offers {
  display: flex;
  flex-direction: column;
  background-color: color('white');
  align-items: flex-end;

  @media (max-width: media('tablet-l')) {
    padding-right: 0;
    padding-left: 0;
    margin-right: 0;
    margin-left: 0;
    width: 100%;
    max-width: inherit;
  }

  &__filters1 {
    width: 100%;
    display: flex;
    flex-direction: row;
    background: color('grey-soft');
  }

  &__filters2 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 2rem 0;
    gap: 3rem;

    @media (max-width: media('tablet-l')) {
      gap: 0;
    }
  }
}

.button-more-filters-mobile {
  display: none;
  background: color('grey-soft');
  @media (max-width: media('tablet-l')) {
    display: inline;
  }
}
</style>
